import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Content from "./Content/container";
import "./style.less";

export type MapProps = RootContainerProps;

export default (props: MapProps) => (
  <Container className="wsc_content_events" {...getContainerProps(props)}>
    <Content {...getRootContainerProps(props)} />
  </Container>
);
